module.exports = __webpack_public_path__ + "img/logo-eol-icon.94ed0e0f.png";